module.exports = __webpack_public_path__ + "static/media/warranty-logo.7c0a67c6.svg";